import { Component } from "react";
import i18next from "i18next";

// Fase 7 (evolução do módulo 3D, combinada com o usuário): Error Boundary
// dedicado só à inspeção 3D. Sem isso, qualquer falha de renderização do
// three.js/@react-three (driver de GPU incomum, contexto WebGL perdido,
// etc.) derrubaria o checklist inteiro -- com o boundary, só a área do 3D
// mostra um aviso, e o resto do checklist (itens, fotos gerais, marcação
// por fotos reais, assinaturas) continua funcionando normalmente.
export default class Vehicle3DErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Falha ao renderizar a inspeção 3D do veículo:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <p className="hint">
          {i18next.t("checklist.avarias_3d_erro")}
        </p>
      );
    }
    return this.props.children;
  }
}
